import { useHttpClient } from './httpClient.js';

const resource = 'lotteries';

export function createLottery(lottery) {
	const form = new FormData();

	form.append('logo', lottery.logo);
	form.append('name', lottery.name);
	form.append('timezone', lottery.timezone);
	return useHttpClient().post(`/${resource}`, form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export function fetchLotteries() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchLottery(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function updateLottery(id, lottery) {
	const form = new FormData();

	form.append('id', id);
	form.append('name', lottery.name);
	form.append('logo', lottery.logo);
	form.append('timezone', lottery.timezone);
	return useHttpClient().put(`/${resource}/${id}`, form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export function generalParams() {
	return useHttpClient().get(`/${resource}/params`);
}
